var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgProfileFeedbackAlert = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-90)",
    d: "M30.228 34.814c0 8.719 7.135 15.796 15.885 15.796s15.868-7.095 15.885-15.796v-9.018C61.998 17.077 54.863 10 46.113 10c-8.768 0-15.885 7.077-15.885 15.796v9.018Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M34.9 36.434c0 7.244 5.734 13.125 12.766 13.125s12.751-5.895 12.765-13.124V28.94c0-7.243-5.733-13.124-12.765-13.124-7.046 0-12.766 5.88-12.766 13.124v7.494Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeWidth: 1.5,
    d: "M61.164 35.41c0 4.646-1.53 8.309-4.148 10.811-2.623 2.507-6.411 3.92-11.053 3.92-4.64 0-8.372-1.412-10.94-3.915-2.565-2.5-4.047-6.162-4.047-10.817 0-1.112-.052-2.85-.105-4.59l-.002-.08c-.054-1.78-.107-3.554-.107-4.713 0-9.82 8.153-15.2 15.201-15.2s15.201 5.38 15.201 15.2v9.384Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M18.556 79.223c5.981 3.141 16.315 6.636 27.408 6.636s21.742-3.495 27.723-6.636a6.502 6.502 0 0 0 3.497-5.4c.497-8.102-2.219-12.25-4.597-14.296-1.136-.989-2.591-1.695-4.42-2.136-6.212-1.483-12.28-5.953-12.351-6.024-6.568 3.746-13.605 3.277-20.174-.007-8.444 5.63-7.282 5.008-11.566 6.031-1.828.441-3.284 1.147-4.42 2.136-2.378 2.047-5.093 6.194-4.597 14.295a6.502 6.502 0 0 0 3.497 5.4Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M35.642 51.36c-.07.07-5.354 4.542-11.566 6.024-1.828.441-3.284 1.147-4.42 2.136-2.378 2.047-5.093 6.194-4.597 14.295.142 2.295 1.635 4.617 3.694 5.694 5.982 3.141 16.118 6.343 27.21 6.343 11.094 0 21.7-3.202 27.68-6.343 2.06-1.077 3.399-3.4 3.54-5.694.498-8.1-2.218-12.248-4.596-14.295-1.136-.989-2.591-1.695-4.42-2.136-6.212-1.482-12.28-5.953-12.351-6.024"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M56.575 75.6 71.75 61.464c1.553-1.446 4.11-.674 4.603 1.39l4.815 20.172c.493 2.064-1.45 3.873-3.495 3.255l-19.99-6.037c-2.045-.617-2.661-3.198-1.108-4.644Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "m70.963 73.704-.87-.263c-.403-.121-.651-.512-.574-.901l.927-5.215c.087-.446.559-.711 1.019-.572l2.058.621c.458.139.706.621.532 1.041l-2.115 4.856c-.151.367-.574.555-.977.433ZM69.62 76.07a1.889 1.889 0 1 0-1.092 3.616 1.889 1.889 0 0 0 1.092-3.616Z",
    clipRule: "evenodd"
  }));
};
export default SvgProfileFeedbackAlert;